// extracted by mini-css-extract-plugin
export default {"skeleton":"skeleton_skeleton__D24Cx","loading":"skeleton_loading__vWDR3"};